import { useMemo } from 'react';

import { getProjectOptions, useProjectOption } from './options';
import { ProjectOption } from './createProjectOption';
import { useMultiKeyPress } from 'hooks';

function SingleShortcut({ option }: { option: ProjectOption }) {
  const { shortcut, action, isEnabled } = useProjectOption(option);

  const { key, triggerKey } = shortcut!;

  useMultiKeyPress({
    key,
    triggerKey,
    action,
    isEnabled,
  });

  return null;
}

export function ProjectOptionShortcuts() {
  const options = useMemo(
    () => Object.values(getProjectOptions()).filter((o) => o.shortcut && !o.shortcut.visualOnly),
    [],
  );

  return (
    <>
      {options.map(({ option }) => (
        <SingleShortcut option={option} key={option} />
      ))}
    </>
  );
}
